import axios from "axios";
import { EscrowTransaction } from "../types/exchange"; // Adjust path if needed

export const getAllEscrows = async (): Promise<EscrowTransaction[]> => {
  const res = await axios.get("/api/exchange/escrow/all", {
    headers: { Authorization: "Bearer " + localStorage.getItem("token") },
  });
  return res.data;
};
